import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
    templateUrl: './frame.html',
    styleUrls: ['./frame.scss']
})
export class SSOFrame {

    constructor(
        public pageTitleService: Title,
    ) {
        this.pageTitleService.setTitle("FirstConnect - SSO");
    }
}